// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header{
  background-color: black;
}
.header2{
  background-color: white
}

h1{
  display: flex;
  justify-content: center;
}

.dynamic-box{
  background-color: #dbd5cd87; 
  padding: 50px; 
  margin-left: auto;
  margin-right: auto;
  min-height: min-content;
  min-width: min-content;
}

.button-p{
  appearance: none;
  background-color: transparent;
  border: 2px solid hsl(0, 0%, 99%);
  border-radius: 15px;
  box-sizing: border-box;
  color: #000000;
  display: inline-block;
  margin: 10px 50px;
  font-family: Roobert,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  width: 200px; 
  height: 200px; 
  padding: 10px;
  outline: none;
  padding: 16px 24px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  will-change: transform;
}

.button-p:disabled {
  pointer-events: none;
}

.button-p:hover {
  color: #000000;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
  transform: translateY(-2px);
}

.button-p:active {
  box-shadow: none;
  transform: translateY(0);
}

.main-button-pantry {
  text-align: center;
}

.button-pantry1 {
  text-align: center;
  padding: 20px;
}

.button-pantry2 {
  text-align: center;
  padding: 20px;
}

.epack-button-pantry {
  text-align: center;
  padding: 20px;
}

.pantry-button-pantry {
  text-align: center;
  padding: 20px;
}

.request-epack{
  margin-left: auto;
  margin-right: auto;
  padding: 50px;
  text-align: center;
}

.button-request{
  appearance: none;
  background-color: transparent;
  border: 2px solid hsl(0, 0%, 0%);
  border-radius: 15px;
  box-sizing: border-box;
  color: #000000;
  display: inline-block;
  margin: 10px 50px;
  font-family: Roobert,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  font-size: 14px;
  font-weight: 300;
  line-height: normal;
  width: 200px; 
  height: 50px; 
  padding: 100px;
  outline: none;
  padding: 16px 24px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  will-change: transform;
  margin-left: auto !important;
  margin-right: auto !important;
}

.button-request:disabled {
  pointer-events: none;
}

.button-request:hover {
  color: #000000;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
  transform: translateY(-2px);
}

.button-request:active {
  box-shadow: none;
  transform: translateY(0);
}

.dynamic-box1{
  background-color: #dbd5cd87; 
  padding: 10px; 
  margin-left: auto !important;
  margin-right: auto !important;
  width: 350px;
  margin-bottom: 50px;
}

.notification-table {
  width: 300px !important;
  border-collapse: collapse;
  border: 1px solid #dbd5cd;
  background-color: #ffffff;
  margin-left: auto !important;
  margin-right: auto !important;
}

.notification-table th,
.notification-table td {
  padding: 8px;
  text-align: center;
  border-bottom: 1px solid #dbd5cd;
  background-color: #ffffff;
}

.notification-table th {
  background-color: #dbd5cd;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/pages/style/Menu.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;AACzB;AACA;EACE;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,kJAAkJ;EAClJ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mDAAmD;EACnD,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,kJAAkJ;EAClJ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mDAAmD;EACnD,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":["\n.header{\n  background-color: black;\n}\n.header2{\n  background-color: white\n}\n\nh1{\n  display: flex;\n  justify-content: center;\n}\n\n.dynamic-box{\n  background-color: #dbd5cd87; \n  padding: 50px; \n  margin-left: auto;\n  margin-right: auto;\n  min-height: min-content;\n  min-width: min-content;\n}\n\n.button-p{\n  appearance: none;\n  background-color: transparent;\n  border: 2px solid hsl(0, 0%, 99%);\n  border-radius: 15px;\n  box-sizing: border-box;\n  color: #000000;\n  display: inline-block;\n  margin: 10px 50px;\n  font-family: Roobert,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: normal;\n  width: 200px; \n  height: 200px; \n  padding: 10px;\n  outline: none;\n  padding: 16px 24px;\n  text-align: center;\n  text-decoration: none;\n  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  will-change: transform;\n}\n\n.button-p:disabled {\n  pointer-events: none;\n}\n\n.button-p:hover {\n  color: #000000;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;\n  transform: translateY(-2px);\n}\n\n.button-p:active {\n  box-shadow: none;\n  transform: translateY(0);\n}\n\n.main-button-pantry {\n  text-align: center;\n}\n\n.button-pantry1 {\n  text-align: center;\n  padding: 20px;\n}\n\n.button-pantry2 {\n  text-align: center;\n  padding: 20px;\n}\n\n.epack-button-pantry {\n  text-align: center;\n  padding: 20px;\n}\n\n.pantry-button-pantry {\n  text-align: center;\n  padding: 20px;\n}\n\n.request-epack{\n  margin-left: auto;\n  margin-right: auto;\n  padding: 50px;\n  text-align: center;\n}\n\n.button-request{\n  appearance: none;\n  background-color: transparent;\n  border: 2px solid hsl(0, 0%, 0%);\n  border-radius: 15px;\n  box-sizing: border-box;\n  color: #000000;\n  display: inline-block;\n  margin: 10px 50px;\n  font-family: Roobert,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";\n  font-size: 14px;\n  font-weight: 300;\n  line-height: normal;\n  width: 200px; \n  height: 50px; \n  padding: 100px;\n  outline: none;\n  padding: 16px 24px;\n  text-align: center;\n  text-decoration: none;\n  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n  will-change: transform;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.button-request:disabled {\n  pointer-events: none;\n}\n\n.button-request:hover {\n  color: #000000;\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;\n  transform: translateY(-2px);\n}\n\n.button-request:active {\n  box-shadow: none;\n  transform: translateY(0);\n}\n\n.dynamic-box1{\n  background-color: #dbd5cd87; \n  padding: 10px; \n  margin-left: auto !important;\n  margin-right: auto !important;\n  width: 350px;\n  margin-bottom: 50px;\n}\n\n.notification-table {\n  width: 300px !important;\n  border-collapse: collapse;\n  border: 1px solid #dbd5cd;\n  background-color: #ffffff;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.notification-table th,\n.notification-table td {\n  padding: 8px;\n  text-align: center;\n  border-bottom: 1px solid #dbd5cd;\n  background-color: #ffffff;\n}\n\n.notification-table th {\n  background-color: #dbd5cd;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
